import nonDeliveryDays from './non-delivery-days.container';

export default nonDeliveryDays;
